import axios from '@/jslib/axios'

export const getHomeFireList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/campaign/fire/home/list',
    params,
    ...other
  })
}